var map = {
	"./aguila_negra.png": 447,
	"./aguila_negra_izquierda.jpg": 370,
	"./bar_cartoon.png": 766,
	"./bar_cartoon2.png": 990,
	"./bigcity2.png": 595,
	"./cafeteria_cartoon1.png": 794,
	"./cafeteria_cartoon2.png": 777,
	"./carniceria_cartoon.png": 848,
	"./citytown.png": 377,
	"./factory_cartoon.png": 923,
	"./farmacia_cartoon.png": 521,
	"./gym_cartoon1.png": 887,
	"./gym_cartoon2.png": 612,
	"./hotel_cartoon.png": 907,
	"./libreria_cartoon.png": 789,
	"./login_cartoon1.png": 469,
	"./login_cartoon2.png": 702,
	"./login_cartoon3.png": 180,
	"./logotipo-gestor.png": 164,
	"./minisupermercado_cartoon1.png": 833,
	"./minisupermercado_cartoon2.png": 722,
	"./otros_cartoon1.png": 769,
	"./restaurante_cartoon.png": 335,
	"./salon_de_belleza_cartoon.png": 962,
	"./school_cartoon.png": 215,
	"./taller_mecanico_cartoon.png": 417,
	"./working-beach.png": 253
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 290;